var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13018",
    "data-name": "Path 13018",
    d: "M16.771,1.693H9.753V.76a.744.744,0,1,0-1.487,0v.932H1.239A1.254,1.254,0,0,0,0,2.959V13.774a1.254,1.254,0,0,0,1.239,1.267H7.206L5.58,16.7a.777.777,0,0,0,0,1.074.736.736,0,0,0,1.051,0L9,15.355l2.369,2.422a.73.73,0,0,0,1.051,0,.777.777,0,0,0,0-1.074l-1.626-1.662h5.967A1.254,1.254,0,0,0,18,13.774V2.959a1.254,1.254,0,0,0-1.239-1.267ZM16.523,13.51H1.487V3.213H16.523V13.52Z",
    transform: "translate(0 0)",
    fill: "#868a97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13019",
    "data-name": "Path 13019",
    d: "M6.58,8.33a.761.761,0,0,0-.75.76v1.693a.75.75,0,1,0,1.5,0V9.09A.761.761,0,0,0,6.58,8.33Z",
    transform: "translate(-0.056 0.113)",
    fill: "#868a97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13020",
    "data-name": "Path 13020",
    d: "M8.33,7.43v3.375a.75.75,0,1,0,1.5,0V7.43a.75.75,0,1,0-1.5,0Z",
    transform: "translate(-0.08 0.09)",
    fill: "#868a97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13021",
    "data-name": "Path 13021",
    d: "M11.58,11.588a.761.761,0,0,0,.75-.76V5.76a.75.75,0,1,0-1.5,0v5.068A.761.761,0,0,0,11.58,11.588Z",
    transform: "translate(-0.104 0.068)",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketingIcon.e6d7edee83145a815b2e8ff73dd9c7f5.svg";
export { ForwardRef as ReactComponent };